// extracted by mini-css-extract-plugin
export default {"content":"Performance_content__LAtyr","btn":"Performance_btn__oPPcC"};